var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ride-word"},[_vm._v("购买"+_vm._s(_vm.tabCode==='bike'?'单车':'助力车')+"卡")])}
var staticRenderFns = []

export { render, staticRenderFns }